export const firebaseConfig = {
  apiKey: 'AIzaSyAj4Q0WMApc8VBb2eOhpZgy6Tlban4Y-Z0',
  authDomain: 'illustrateinc-quick-quote.firebaseapp.com',
  databaseURL: 'https://illustrateinc-quick-quote.firebaseio.com',
  projectId: 'illustrateinc-quick-quote',
  storageBucket: 'illustrateinc-quick-quote.appspot.com',
  messagingSenderId: '22528632465',
  appId: "1:22528632465:web:35049967881db6aece8130",
  measurementId: "G-9XSMD10FFF"
};